import script from "./marketplaceView.vue?vue&type=script&setup=true&lang=js"
export * from "./marketplaceView.vue?vue&type=script&setup=true&lang=js"

import "./marketplaceView.vue?vue&type=style&index=0&id=43cd7136&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cd7136"]])

export default __exports__